module.exports = __webpack_public_path__ + "img/Logo-footer.98350ede.svg";